import { Box, Stack } from "@similarweb/ui-components/foundations";

import type { ParsedAIEmailPreview } from "app/pages/sales-intelligence/modules/ai-agent/services/jsonParser/types";
import type { AiAgentEmailAutocompleteCompany } from "app/pages/sales-intelligence/modules/ai-agent/types/email";
import { AIAgentEmailGraphContainer } from "app/pages/sales-intelligence/modules/ai-agent/containers/AIAgentEmailGraph/AIAgentEmailGraphContainer";

type AIAgentEmailVisualsProps = {
    emailPreviews?: ParsedAIEmailPreview[];
    selectedCompany: AiAgentEmailAutocompleteCompany | null;
    onApplyVisual: (preview: ParsedAIEmailPreview) => void;
};

export const AIAgentEmailVisuals = ({ emailPreviews, selectedCompany, onApplyVisual }: AIAgentEmailVisualsProps) => {
    const handleApplyVisual = (index: number) => {
        const preview = emailPreviews?.[index];
        if (preview) {
            onApplyVisual(preview);
        }
    };

    if (!emailPreviews?.length) {
        return null;
    }
    return (
        <Stack
            gap="16px"
            margin="16px 0"
        >
            {emailPreviews.map((preview, index) => (
                <Box
                    key={index}
                    data-automation="visual-container"
                >
                    <AIAgentEmailGraphContainer
                        chart={preview.chartJson}
                        selectedCompany={selectedCompany}
                        isSimplifiedView
                        onApplyVisual={() => handleApplyVisual(index)}
                    />
                </Box>
            ))}
        </Stack>
    );
};
